import { useSyncExternalStore } from "react";

// „Часовникът" на обедните менюта: брояч, който расте всеки път, когато обедно
// меню трябва да се появи или изчезне. `useMenu` го слага в зависимостите на
// `select`, за да преизчисли активните обедни групи БЕЗ нова заявка — така
// групата изчезва навреме и без интернет (касата връща старото копие на
// менюто). Кой го мести: `useLunchCatalogRefresh` в „Маркиране".

let tick = 0;
const listeners = new Set<() => void>();

export const bumpLunchClock = () => {
  tick += 1;
  listeners.forEach((listener) => listener());
};

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const useLunchClockTick = () =>
  useSyncExternalStore(subscribe, () => tick, () => tick);

// Разликата „часовник на сървъра − часовник на терминала". Обедното меню се
// показва/скрива по `lunchNow()`, за да изчезне в същата секунда, в която
// сървърът спира да го приема — и на терминал с избързал/изостанал часовник.
// Сверява се САМО по отговор от облака (`getMenu`); офлайн остава последната
// разлика (копието в касата носи старо време).
let serverSkewMs = 0;

export const noteLunchServerTime = (serverTime: string | null | undefined) => {
  const serverMs = serverTime ? Date.parse(serverTime) : Number.NaN;
  if (Number.isFinite(serverMs)) serverSkewMs = serverMs - Date.now();
};

export const lunchNow = () => new Date(Date.now() + serverSkewMs);
